import React, { useEffect, useState } from 'react'
import { CCol, CForm, CFormInput, CFormLabel, CInputGroup, CRow } from '@coreui/react'
import { Dialog } from 'primereact/dialog'
import { Checkbox } from 'primereact/checkbox'
import { Button } from '@mui/material'
import { useAuth } from '../contexts/AuthContext'
import { usePrinter } from '../contexts/PrinterContext'
import CInput from './CInput'

function AddPrinter({ visible, editMode, editPrinterId, handleClose, fetchPrinters, canAccessBackupPrinterIp }) {
    const { getSinglePrinter, createPrinter, updatePrinter } = usePrinter();
    const { restaurantId } = useAuth();

    const [validated, setValidated] = useState(false);
    const [printerDetail, setPrinterDetail] = useState({
        name: '',
        type: '',
        ip_address: '',
        backup_ip_address: '',
        no_of_prints: 1,
        send_to_both: 0,
        restaurant_id: restaurantId,
    });

    useEffect(() => {
        fetchSinglePrinter();
    }, [editMode, editPrinterId]);

    const fetchSinglePrinter = async () => {
        if (editPrinterId) {
            const printer = await getSinglePrinter(editPrinterId)
            if (printer) {
                setPrinterDetail(printer.data);
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        setValidated(true);

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (visible && restaurantId) {
                    const data = await createPrinter({ ...printerDetail, restaurant_id: restaurantId });
                    if (!data.error) {
                        handleClose();
                        setPrinterDetail({
                            name: '',
                            type: '',
                            ip_address: '',
                            no_of_prints: 1,
                            send_to_both: 0,
                            restaurant_id: restaurantId
                        });
                        fetchPrinters()
                    }
                } else if (editMode && editPrinterId && restaurantId) {
                    const data = await updatePrinter(editPrinterId, { ...printerDetail, restaurant_id: restaurantId });
                    if (!data.error) {
                        handleClose();
                        setPrinterDetail({
                            name: '',
                            type: '',
                            ip_address: '',
                            no_of_prints: 1,
                            send_to_both: 0,
                            restaurant_id: restaurantId
                        });
                        fetchPrinters()
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
    }
    return (
        <div>
            <Dialog draggable={false} header={`${visible ? 'Create Printer' : 'Edit Printer'}`} visible={visible || (editMode && editPrinterId !== null)} style={{ width: '30vw' }} onHide={handleClose}>
                <CForm onSubmit={handleSubmit} noValidate validated={validated}>
                    <div className='fields-container'>
                        <CRow className="mb-3 mt-3">
                            <CInput
                                label="Name"
                                type="text"
                                value={printerDetail.name}
                                onChange={(value) => setPrinterDetail({ ...printerDetail, name: value })}
                                required={true}
                                disabled={printerDetail.name === 'Admin'}
                                errorMessage='Name is required.'
                            />
                        </CRow>
                        <CRow className="mb-3">
                            <CInput
                                label="Type"
                                type="text"
                                value={printerDetail.type}
                                onChange={(value) => setPrinterDetail({ ...printerDetail, type: value })}
                                required={true}
                                errorMessage='Type is required.'
                            />
                        </CRow>
                        <CRow className="mb-3">
                            <CInput
                                label="Printer IP"
                                type="text"
                                value={printerDetail.ip_address}
                                onChange={(value) => setPrinterDetail({ ...printerDetail, ip_address: value })}
                                required={true}
                                errorMessage='Printer IP is required.'
                            />
                        </CRow>
                        {canAccessBackupPrinterIp &&
                            <CRow className="mb-3">
                                <CInput
                                    label="Backup Printer IP"
                                    type="text"
                                    value={printerDetail.backup_ip_address}
                                    onChange={(value) => setPrinterDetail({ ...printerDetail, backup_ip_address: value })}
                                    required={false}
                                    errorMessage='Backup Printer IP is required.'
                                />
                            </CRow>
                        }
                        <CRow className="mb-3">
                            <div className='d-flex flex-column'>
                                <div className='w-50'>
                                    <CFormLabel className="form-label">Number Of Prints <span className="text-danger">*</span></CFormLabel>
                                </div>
                                <div className='w-100'>
                                    <CFormInput
                                        type="number"
                                        step="any"
                                        min={0}
                                        value={printerDetail.no_of_prints}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            if (newValue >= 0) {
                                                setPrinterDetail({ ...printerDetail, no_of_prints: newValue })
                                            }
                                        }}
                                        required
                                        feedbackInvalid='Number Of Prints is required.'
                                    />
                                </div>
                            </div>
                        </CRow>
                        <CRow className='mb-4'>
                            <CCol lg={4}>
                                <CFormLabel className="form-label pt-1">Send To Both</CFormLabel>
                            </CCol>
                            <CCol lg={8} className="custom-checkbox mx-0 px-0">
                                <Checkbox
                                    checked={printerDetail.send_to_both === 1}
                                    onChange={(event) => setPrinterDetail({ ...printerDetail, send_to_both: event.target.checked ? 1 : 0 })}
                                />
                            </CCol>
                        </CRow>
                    </div>
                    <div className="d-flex p-jc-end justify-content-end button-container">
                        <div className='d-flex'>
                            <Button onClick={handleClose} fullWidth variant="contained" color="inherit" >
                                Cancel
                            </Button>
                            <Button fullWidth variant="contained" color='primary' type="submit" className='ms-3'>
                                Submit
                            </Button>
                        </div>
                    </div>
                </CForm>
            </Dialog>
        </div>
    )
}

export default AddPrinter